import axios from "axios";
import axios from "axios";
import baseurl from "./customURl";

export const UpdateEventType = async (EventType, id) => {
  console.log(EventType);
  console.log(id);

  try {
    const response = await axios.post(`${baseurl}/EventType/UpdateEventType`, {
      EventTypeId: id,

      EventTypeName: EventType,
    });

    console.log(response);
    return response;
  } catch (error) {
    return error.response;
  }
};
//update GeoTagInterval
export const UpdateGeoTag = async (
  EventDetailId,
  Id,
  IntervalInMinutes,
  Status
) => {
  console.log(Id);
  console.log(IntervalInMinutes);
  console.log(EventDetailId);
  console.log(Status);

  try {
    const response = await axios.post(
      `${baseurl}/geoTag/UpdateGeoTagGenerationRequest`,
      {
        Id: Id,
        EventDetailId: EventDetailId,
        IntervalInMinutes: IntervalInMinutes,
        Status: Status,
      }
    );

    console.log(response);
    return response;
  } catch (error) {
    return error.response;
  }
};

// updateSkillInDataBase

export const updateSkillInDataBase = async (SkillName, Status, SkillsId) => {
  console.log(SkillName);
  console.log(Status);
  console.log(SkillsId);

  try {
    const response = await axios.post(`${baseurl}/Skill/UpdateSkill`, {
      SkillId: SkillsId,
      SkillName: SkillName,
      Status: Status,
    });

    console.log(response);
    return response;
  } catch (error) {
    return error.response;
  }
};

// updateStaffInDataBase

export const updateStaffInDataBase = async (
  fullName,
  contact,
  department,
  Gender,
  designation,
  base64Image,
  address,
  CommunityId,
  isAvailable,
  StaffId
) => {
  console.log(base64Image);

  let file = null;

  try {
    const response = await axios.post(`${baseurl}/staff/UpdateStaff`, {
      StaffId: StaffId,
      FullName: fullName,
      ContactNo: contact,
      Department: department,
      Gender: Gender,
      Designation: designation,
      StaffImage: base64Image,
      CommunityId: CommunityId,
      Address: address,
      isAvailable: isAvailable,
    });

    console.log(response);
    return response;
  } catch (error) {
    return error.response;
  }
};

// updateEventDetailsInDataBase

export const updateEventDetailsInDataBase = async (
  EventType,
  EventName,
  StartDate,
  EndDate,
  StartLocation,
  EndLocation,
  Status,
  Priority,
  Description,
  EventDetailsId,
  CommunityId
) => {
  console.log(EventDetailsId);

  console.log(
    EventType,
    EventName,
    StartDate,
    EndDate,
    StartLocation,
    EndLocation,
    Status,
    Priority,
    Description
  );

  try {
    const response = await axios.post(
      `${baseurl}/eventDetails/UpdateEventDetails`,
      {
        EventDetailId: EventDetailsId,
        EventTypeId: EventType,
        EventName: EventName,
        StartDate: StartDate,
        EndDate: EndDate,
        StartLocation: StartLocation,
        EndLocation: EndLocation,
        Priority: Priority,
        Description: Description,
        Status: Status,
        CommunityId: CommunityId,
      }
    );

    console.log(response);
    return response;
  } catch (error) {
    return error.response;
  }
};

// UpdateAreaInDataBase

export const UpdateAreaInDataBase = async (
  AreaId,
  AreaName,
  DistrictId,
  StateId,
  Pincode,
  LandMark,
  EventDetailId,
  NoOfDeputation,
  Skills,
  Status,
  DutyEndTime,
  DutyStartTime
) => {
  try {
    const payload = {
      Area: {
        AreaName,
        DistrictId,
        StateId,
        Pincode,
        LandMark,
        EventDetailId,
        NoOfDeputation,
        Status,
        StartTime: DutyStartTime,
        EndTime: DutyEndTime,
      },
      DeputationSkills: Skills.map((skillId) => ({
        SkillId: parseInt(skillId),
      })),
    };

    const response = await axios.post(
      `${baseurl}/Area/UpdateArea/${AreaId}`,
      payload
    );

    console.log("✅ Area update response:", response.data);
    return response;
  } catch (error) {
    console.error(
      "❌ Area update error:",
      error?.response?.data || error.message
    );
    return error.response;
  }
};

export const updateStaffSkillInDataBase = async (
  StaffSkillId,
  StaffId,
  SkillsId,
  Status
) => {
  console.log(StaffSkillId, StaffId, SkillsId, Status);

  try {
    const response = await axios.post(
      `${baseurl}/staffSkills/UpdateStaffSkill`,
      {
        StaffSkillId,
        StaffId,
        SkillId: SkillsId,
        Status,
      }
    );

    console.log(response);
    return response;
  } catch (error) {
    return error.response;
  }
};

// updateDutyAllotementInDatabase

export const updateDutyAllotementInDatabase = async (
  AreaId,
  ManualAllotementData,
  staffIds,
  ReplaceExisting,
  ReplaceMap = {}
) => {
  console.log("AreaId:", AreaId);
  console.log("ManualAllotementData:", ManualAllotementData);
  console.log("staffIds:", staffIds);
  console.log("ReplaceExisting:", ReplaceExisting);
  console.log("ReplaceMap:", ReplaceMap);

  try {
    const payload = ReplaceExisting ? { ReplaceExisting: true, ReplaceMap }
      : { ReplaceExisting: false, StaffIds: staffIds };

    const response = await axios.post(
      `${baseurl}/Allotment/Replacement/${ManualAllotementData}/${AreaId}`,
      payload
    );

    return response;
  } catch (error) {
    console.error("Error in updateDutyAllotementInDatabase:", error);
    throw error;
  }
};
